// extracted by mini-css-extract-plugin
module.exports = {"editableInput":"EditableInput_editableInput__2jKhu","textLabel":"EditableInput_textLabel__3L-FK"};